export const labels = {
    getContractTypeNames,
    getContractLanguages,
    getContractTypeName,
    getLanguageName,
    getConceptName
};

const CONTRACT_TYPES = [
    "ProcurementAgreement",
    "CustomerAgreement",
    "Unknown",
    "NDA_Customer",
    "NDA_Seller",
    "NDA_Mutual",
    "EULA_Customer",
    "EULA_Seller",
    "DistributionAgreement_Customer",
    "DistributionAgreement_Seller",
    "DPA_Controller",
    "DPA_Processor",
    "LicenseAgreement_Customer",
    "LicenseAgreement_Seller",
    "SourcingOfGoods_Customer",
    "SourcingOfGoods_Seller",
    "Services_Customer",
    "Services_Seller",
    "PersonalServices_Customer",
    "PersonalServices_Seller"
];

const LANGUAGES = [
    "en",
    "sv"
];

function getContractTypeNames() {
    return CONTRACT_TYPES;
}

function getContractLanguages() {
    return LANGUAGES;
}

function getContractTypeName(type) {
    switch (type) {
        case "ProcurementAgreement": return "Procurement Agreement";
        case "CustomerAgreement": return "Customer Agreement";
        case "NDA_Customer": return "NDA - receiving information";
        case "NDA_Seller": return "NDA - giving information";
        case "NDA_Mutual": return "NDA - both giving and receiving information";
        case "EULA_Seller": return "EULA - Seller";
        case "EULA_Customer": return "EULA - Customer";
        case "DistributionAgreement_Customer": return "Distribution Agreement - Customer";
        case "DistributionAgreement_Seller": return "Distribution Agreement - Seller";
        case "DPA_Controller": return "DPA - Controller";
        case "DPA_Processor": return "DPA - Processor";
        case "LicenseAgreement_Customer": return "License Agreement - Customer";
        case "LicenseAgreement_Seller": return "License Agreement - Seller";
        case "SourcingOfGoods_Customer": return "Sourcing of Goods - Customer";
        case "SourcingOfGoods_Seller": return "Sourcing of Goods - Seller";
        case "Services_Customer": return "Services - Customer";
        case "Services_Seller": return "Services - Seller";
        case "PersonalServices_Customer": return "Personal Services - Customer";
        case "PersonalServices_Seller": return "Personal Services - Seller";
        case "Unknown": return "Unknown";
        default: return "Unknown";
    }
}
function getLanguageName(lang) {
    switch (lang) {
        case "en": return "English";
        case "sv": return "Swedish";
    }
}

function getConceptName(code) {
    switch (code) {
        case "C2": return "Definition of information";
        case "C3": return "Restricted use of information";
        case "C4": return "Return and destruction";
        case "C8": return "Need to know";
        case "Non-solicitation": return "Non-Solicitation";
        case "Termination_convenience": return "Termination - Convenience";
        case "Termination_breach": return "Termination - Breach";
        case "Termination_coc": return "Termination - Change of Control";
        default: return "";
    }
}


// WEBPACK FOOTER //
// ./src/helpers/labels.js